const TMS = {
  TMS_MANAGE_BASE_SECTION_REPORT: 'tms/manage/base/section/report',
  TMS_MANAGE_BASE_SECTION_LIST: 'tms/manage/base/section/list',
  TMS_MANAGE_BASE_SECTION_GET: 'tms/manage/base/section/get',
  TMS_MANAGE_BASE_SECTION_CREATE: 'tms/manage/base/section/create',
  TMS_MANAGE_BASE_SECTION_UPDATE: 'tms/manage/base/section/update',
  TMS_MANAGE_BASE_SECTION_DELETE: 'tms/manage/base/section/delete',
  TMS_MANAGE_BASE_SECTION_ENABLE: 'tms/manage/base/section/enable',
  TMS_MANAGE_BASE_SECTION_DISABLE: 'tms/manage/base/section/disable',

  TMS_MANAGE_BASE_ORGANIZATION_REPORT: 'tms/manage/base/department/report',
  TMS_MANAGE_BASE_ORGANIZATION_LIST: 'tms/manage/base/department/list',
  TMS_MANAGE_ACTIVITY_DUPLICATE: 'tms/manage/activity/duplicate',
  TMS_MANAGE_BASE_ORGANIZATION_GET: 'tms/manage/base/department/get',
  TMS_MANAGE_BASE_ORGANIZATION_CREATE: 'tms/manage/base/department/create',
  TMS_MANAGE_BASE_ORGANIZATION_UPDATE: 'tms/manage/base/department/update',
  TMS_MANAGE_BASE_ORGANIZATION_DELETE: 'tms/manage/base/department/delete',
  TMS_MANAGE_BASE_ORGANIZATION_ENABLE: 'tms/manage/base/department/enable',
  TMS_MANAGE_BASE_ORGANIZATION_DISABLE: 'tms/manage/base/department/disable',

  TMS_MANAGE_BASE_TASK_REPORT: 'tms/manage/base/task/report',
  TMS_MANAGE_BASE_TASK_LIST: 'tms/manage/base/task/list',
  TMS_MANAGE_BASE_TASK_GET: 'tms/manage/base/task/get',
  TMS_MANAGE_BASE_TASK_CREATE: 'tms/manage/base/task/create',
  TMS_MANAGE_BASE_TASK_UPDATE: 'tms/manage/base/task/update',
  TMS_MANAGE_BASE_TASK_DELETE: 'tms/manage/base/task/delete',
  TMS_MANAGE_BASE_TASK_ENABLE: 'tms/manage/base/task/enable',
  TMS_MANAGE_BASE_TASK_DISABLE: 'tms/manage/base/task/disable',

  TMS_MANAGE_BASE_TASKUNIT_REPORT: 'tms/manage/base/taskUnit/report',
  TMS_MANAGE_BASE_TASKUNIT_LIST: 'tms/manage/base/taskUnit/list',
  TMS_MANAGE_BASE_TASKUNIT_GET: 'tms/manage/base/taskUnit/get',
  TMS_MANAGE_BASE_TASKUNIT_CREATE: 'tms/manage/base/taskUnit/create',
  TMS_MANAGE_BASE_TASKUNIT_UPDATE: 'tms/manage/base/taskUnit/update',
  TMS_MANAGE_BASE_TASKUNIT_DELETE: 'tms/manage/base/taskUnit/delete',
  TMS_MANAGE_BASE_TASKUNIT_ENABLE: 'tms/manage/base/taskUnit/enable',
  TMS_MANAGE_BASE_TASKUNIT_DISABLE: 'tms/manage/base/taskUnit/disable',

  TMS_USER_ACTIVITY_CREATE: 'tms/user/activity/create',
  TMS_USER_ACTIVITY_UPDATE: 'tms/user/activity/update',
  TMS_USER_ACTIVITY_REPORT: 'tms/user/activity/report',
  TMS_USER_ACTIVITY_DELETE: 'tms/user/activity/delete',
  TMS_USER_ACTIVITY_GET: 'tms/user/activity/get',
  TMS_USER_ACTIVITY_EXIST: 'tms/user/activity/exist',
  TMS_USER_ACTIVITY_OVERFLOW: 'tms/user/activity/overflow',

  TMS_MANAGE_ACTIVITY_CREATE: 'tms/manage/activity/create',
  TMS_MANAGE_ACTIVITY_REPORT: 'tms/manage/activity/report',
  TMS_MANAGE_ACTIVITY_HISTORY: 'tms/manage/activity/history',
  TMS_MANAGE_ACTIVITY_ACCEPET: 'tms/manage/activity/accept',
  TMS_MANAGE_ACTIVITY_REJECT: 'tms/manage/activity/reject',
  TMS_MANAGE_ACTIVITY_REVERT: 'tms/manage/activity/revert',

  TMS_REPORT_ACTIVITY_PERCENT_SIMPLE: 'tms/report/activity/percent/simple',
  TMS_REPORT_ACTIVITY_PERCENT_JALALI: 'tms/report/activity/percent/jalali',
  TMS_REPORT_ACTIVITY_FUNCTIONALITY: 'tms/report/activity/functionality/master',
  TMS_REPORT_ACTIVITY_FUNCTIONALITY_DETAIL: 'tms/report/activity/functionality/detail'
}
export default TMS
